<template>
	<!-- Vue Material Autocomplete -->
	<!-- https://vuematerial.io/components/autocomplete -->

	<!-- Note: keyup.enter event not available in md-autocomplete component,
	MdAutocomplete.vue should have v-on="$listeners" inside md-input to expose all listeners -->
	<md-autocomplete
		ref="autoComplete"
		:class="{ 'md-invalid': errorMessage }"
		:md-fuzzy-search="false"
		:md-open-on-focus="false"
		:md-options="options"
		:md-input-placeholder="placeholder"
		:required="required"
		:value="value"
		class="ui-autocomplete"
		autocomplete="off"
		@input="$emit('input', trim && typeof $event === 'string' ? $event.trim() : $event)"
		@keyup.native.enter="$emit('enter')"
		@md-changed="$emit('change', $event)"
		@md-opened="setStyles"
		@md-selected="selected"
	>
		<label>{{ label }}</label>
		<span v-if="errorMessage" class="md-error">{{ errorMessage }}</span>
	</md-autocomplete>
</template>

<script>
import UiInputValidator from "lib/components/ui/InputValidator";
import UiValidator from "lib/components/ui/Validator";

export default {
	name: "Autocomplete",
	mixins: [UiInputValidator, UiValidator],
	props: {
		label: {
			type: String,
			default: "",
			required: false
		},
		options: {
			type: Array,
			default: () => [],
			required: false
		},
		placeholder: {
			type: String,
			default: "",
			required: false
		},
		trim: {
			type: Boolean,
			default: true,
			required: false
		},
		value: {
			type: String,
			default: "",
			required: false
		}
	},
	methods: {
		close() {
			this.$el.querySelector("input").blur();
			this.$refs.autoComplete.showMenu = false;
		},
		// workaround to get the menu to close when clicking the first menu item when md-open-on-focus is false (Safari)
		selected(item) {
			this.$emit("select", item);
			this.$nextTick(() => {
				this.$refs.autoComplete.showMenu = false;
			});
		},
		setStyles() {
			// workaround to trigger setStyles on MdMenu open, this is needed to make
			// the MdMenu size the same as the input field (can change if field has dynamic width)
			// MdAutocomplete -> MdField -> MdMenu -> MdMenuContent.setStyles()
			this.$refs.autoComplete.$children[0].$children[0].$children[1].setStyles();
		}
	}
};
</script>
